import { render, staticRenderFns } from "./BrokerMembers.vue?vue&type=template&id=3a41a00a&scoped=true"
import script from "./BrokerMembers.vue?vue&type=script&lang=js"
export * from "./BrokerMembers.vue?vue&type=script&lang=js"
import style0 from "./BrokerMembers.vue?vue&type=style&index=0&id=3a41a00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a41a00a",
  null
  
)

export default component.exports